// extracted by mini-css-extract-plugin
export var container = "_no-0";
export var dotAnimation = "_no-2";
export var dotsLoading = "_no-1";